const util = require("./Util.js");

async function createInvoiceInstallment({merchantId, merchantAccessCode, merchantHashCode, vpcMerTxnRef, returnURL, againLink, amount, orderInfo, cardList, customerId, customerEmail, customerPhone}) {
  let merchantParam = {
    vpc_ReturnURL: returnURL,
    vpc_OrderInfo: orderInfo,
    vpc_Amount: `${amount * 100}`, // amount >= 3.000.000 VND
    vpc_TicketNo: await util.getIPAddress(),
    AgainLink: againLink,
    Title: "Trả góp",
    vpc_MerchTxnRef: vpcMerTxnRef,
    vpc_Version: "2",
    vpc_Currency: "VND",
    vpc_Command: "pay",
    vpc_AccessCode: merchantAccessCode,
    vpc_Merchant: merchantId,
    vpc_Locale: "vn",
    // // vpc_ItaFeeAmount:`${amount * 100 * .1}`,
    vpc_Customer_Phone: customerPhone,
    vpc_Customer_Email: customerEmail,
    vpc_Customer_Id: customerId,
  };
  let sortedParam = util.sortObj(merchantParam);
  let stringToHash = util.generateStringToHash(sortedParam);
  let secureHash = util.genSecureHash(stringToHash, merchantHashCode);
  merchantParam["vpc_SecureHash"] = secureHash;
  let urlRequest =
    process.env.REACT_APP_ONEPAY_URL + process.env.REACT_APP_URL_PREFIX + new URLSearchParams(merchantParam);
  util.sendHttpsGet(urlRequest);
}

module.exports = {
  createInvoiceInstallment,
};
